module.exports = __webpack_public_path__ + "img/solution-network-system-pic.316004c2.png";